import { EMAIL_REGEX } from "@circle-react/components/OnboardingPage/helpers/constants";
import { CheckoutForm } from "@circle-react/components/Paywalls/Checkout/CheckoutV2/CheckoutForm";
import { CheckoutFormField } from "../../CheckoutFormField";

export const CheckoutFormEmailField = () => (
  <CheckoutForm.Item name="email">
    <CheckoutFormField
      type="text"
      name="email"
      options={{
        required: true,
        pattern: EMAIL_REGEX,
      }}
    />
  </CheckoutForm.Item>
);
